import { render, staticRenderFns } from "./DocumentSections.vue?vue&type=template&id=9c1b84de&"
import script from "./DocumentSections.vue?vue&type=script&lang=js&"
export * from "./DocumentSections.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports